var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRadio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 10a2.5 2.5 0 00-2.5-2.5H8.154a.25.25 0 01-.106-.476L18.926 1.9a1 1 0 10-.852-1.8L2.366 7.488a.254.254 0 01-.085.022A2.5 2.5 0 000 10v10a2.5 2.5 0 002.5 2.5h.75a.25.25 0 01.25.25V23a1 1 0 002 0v-.25a.25.25 0 01.25-.25h12.5a.25.25 0 01.25.25V23a1 1 0 002 0v-.25a.25.25 0 01.25-.25h.75A2.5 2.5 0 0024 20zm-4.5 11a1.5 1.5 0 111.5-1.5 1.5 1.5 0 01-1.5 1.5zm.5-4.5H4a2 2 0 01-2-2V14a.25.25 0 01.25-.25h19.5A.25.25 0 0122 14v.5a2 2 0 01-2 2zM4.5 21A1.5 1.5 0 116 19.5 1.5 1.5 0 014.5 21zM22 12a.25.25 0 01-.25.25H2.25A.25.25 0 012 12v-.5a2 2 0 012-2h16a2 2 0 012 2z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadio);
export default __webpack_public_path__ + "static/media/radio.dfa092fb.svg";
export { ForwardRef as ReactComponent };